import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  CreateEecsProductPayload,
  DeleteEecsProductPayload,
  FetchEecsProductsPayload,
  IEecsProduct,
  SaveProductOrderPayload,
  UpdateEecsProductPayload,
} from '../types/eecs-products.types';

export const eecsProductsApi = createApi({
  reducerPath: 'eecsProductsApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/platform-settings/eecs-products`),
  endpoints: (builder) => ({
    fetchProducts: builder.query<ApiPaginationResponse<IEecsProduct[]>, FetchEecsProductsPayload>({
      query: (payload) => ({
        url: ``,
        method: 'GET',
        params: payload,
      }),
    }),

    createProduct: builder.mutation<ApiResponse<IEecsProduct>, CreateEecsProductPayload>({
      query: (payload) => ({
        url: ``,
        method: 'POST',
        body: payload,
      }),
    }),

    updateProduct: builder.mutation<ApiResponse<IEecsProduct>, UpdateEecsProductPayload>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
    }),

    saveProductOrder: builder.mutation<ApiResponse<void>, SaveProductOrderPayload>({
      query: (payload) => ({
        url: `/order`,
        method: 'PUT',
        body: payload,
      }),
    }),

    deleteProduct: builder.mutation<ApiResponse<void>, DeleteEecsProductPayload>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useLazyFetchProductsQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useSaveProductOrderMutation,
} = eecsProductsApi;
